<!-- 集体预约  -->
<template>
  <div class="appointmentDiv">
    <div class="topImgDiv">
      <img src="../../assets/image/btn_fanxiao.png"
        alt="欢迎回家"
        class="welcomeImg"/>
    </div>
    <el-form
      label-position="top"
      :model="appointmentInfoForm"
      :rules="appointmentInfoRules"
      ref="ruleForm"
      class="ruleForm">
      <div class="section-box">
        <div class="titleDiv">
          <div class="titleIcon"></div>
          <div class="titleWord">基本信息</div>
        </div>
        <div class="form-item-box">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="appointmentInfoForm.name" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机" prop="phone">
            <el-input v-model="appointmentInfoForm.phone" placeholder="请输入您的手机号"></el-input>
          </el-form-item>
          <el-form-item label="主题" prop="thame">
            <el-input v-model="appointmentInfoForm.thame" placeholder="如：毕业二十周年返校"></el-input>
          </el-form-item>
          <el-form-item label="人数" prop="number">
            <el-input v-model="appointmentInfoForm.number" placeholder="请输入返校人数"></el-input>
          </el-form-item>
          <el-form-item label="返校日期">
            <div class="date-check-box">
              <el-date-picker
                v-model="appointmentInfoForm.startDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始日期">
              </el-date-picker>
              <span style="margin-right: 10px;">-</span>
              <el-date-picker
                v-model="appointmentInfoForm.endDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="结束日期">
              </el-date-picker>
            </div>
          </el-form-item>
        </div>
      </div>
      <div class="section-box">
        <div class="titleDiv">
          <div class="titleIcon"></div>
          <div class="titleWord">服务信息</div>
        </div>
        <div class="form-item-box">
          <el-checkbox v-model="appointmentInfoForm.needCar" :true-label="1" :false-label="0">需要协助预订车辆</el-checkbox>
          <el-checkbox v-model="appointmentInfoForm.needHotel" :true-label="1" :false-label="0">需要协助预定酒店</el-checkbox>
          <el-checkbox v-model="appointmentInfoForm.needPavilion" :true-label="1" :false-label="0">需要预约参观展馆</el-checkbox>
          <el-checkbox v-model="appointmentInfoForm.needAcademy" :true-label="1" :false-label="0">需要协助联系学院</el-checkbox>
          <el-checkbox v-model="appointmentInfoForm.needVolunteer" :true-label="1" :false-label="0">需要提供志愿者服务</el-checkbox>
          <el-form-item label="其他要求" prop="needAother">
            <el-input v-model="appointmentInfoForm.needAother" placeholder="请输入您需要的服务"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="appointmentInfoForm.remark" placeholder="请输入备注信息"></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="btnDiv">
      <button class="btn" @click="submit">{{ btnState === 0 ? '提交' : '修改' }}</button>
    </div>
  </div>
</template>

<script>
import {Dialog} from "vant"

export default {
  data() {
    return {
      btnState: 0,
      appointmentInfoForm: {
        userId: window.localStorage.getItem("user_id"),
        name: null,
        phone: null,
        thame: null,
        number: null,
        startDate: null,
        endDate: null,
        needCar: 0,
        needHotel: 0,
        needPavilion: 0,
        needAcademy: 0,
        needVolunteer: 0,
        needAother: null, //其他需求
        remark: null
      },
      appointmentInfoRules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 1,
            max: 8,
            message: "长度在 1 到 8 个字符",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            min: 1,
            max: 11,
            message: "长度在 1 到 11 个字符",
            trigger: "blur",
          },
        ],
        thame: [
          { required: true, message: "请输入主题", trigger: "blur" }
        ]
      }
    }
  },
  created() {
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        if (this.appointmentInfoForm.startDate == null || this.appointmentInfoForm.startDate === '') {
          this.$message('请选择开始时间')
          return
        }
        if(this.appointmentInfoForm.endDate == null || this.appointmentInfoForm.endDate === '') {
          this.$message('请选择结束时间')
          return
        }
        console.log('校验通过')
        Dialog.confirm({
          title: '提示',
          message: '确认预约',
          confirmButtonColor: '#00706E'
        }).then(() => {
          this.apply()
          // on confirm
        }).catch(() => {
          // on cancel
        });
        // await this.$confirm('确认预约', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'info'
        // }).then(() => {
        //   this.apply()
        // }).catch(() => {
        //
        // })
      })
    },
    async apply() {
      // /Homecoming/insertHomeComing
      const res = await this.$http({
        url: "/Homecoming/insertHomeComing",
        method: "POST",
        // headers: {"content-type": "application/x-www-form-urlencoded"},
        data: this.appointmentInfoForm
      })
      if (res.data == null || res.data.code !== 200) {
        this.$message.error('预约失败')
        return
      }
      this.$message.success(res.data.msg)
      this.btnState = 1
      await this.$router.push("/appointmentSucc")
    }
  }
}
</script>

<style lang="less" scoped>
.appointmentDiv {
  padding: 2.666667vw;
  padding-bottom: 6vw;
  .topImgDiv{
    width: 100%;
    .welcomeImg {
      width: 100%;
    }
  }
  .section-box {
    margin-top: 15px;
  }
}
.titleDiv {
  display: flex;
  align-items: center;
  //margin: 15px 0;
  height: 6vw;
  width: 100%;
  .titleIcon {
    width: 6px;
    height: 5.666667vw;
    background-color: #00706E;
    border-radius: 15px;
  }
  .titleWord {
    margin-left: 2.666667vw;
    font-size: 1.3em;
    font-weight: bold;
    color: #333333;
  }
}
.form-item-box {
  margin-top: 15px;
  padding: 4vw 5vw 2.666667vw 5vw;
  border-radius: 10px;
  background-color: #FFFFFF;
  /deep/ .el-form-item {
    margin-bottom: 15px;
  }
  /deep/ .el-form-item__label {
    color: #333333;
    line-height: normal;
    margin-bottom: 0;
    padding: 0;
  }
  //.el-form--label-top .el-form-item__label
  /deep/ .el-form-item__content{
    border-bottom: 1px solid #F3F3F3;
    .el-input .el-input__inner {
      padding: 0;
      border: none;
      background-color: transparent;
    }
    .el-date-editor.el-input {
      width: 80px;
      padding: 0;
      border: none;
      background-color: transparent;
      i{
        display: none;
      }
    }
  }
  /deep/ .el-checkbox {
    margin-bottom: 15px;
  }
}
.date-check-box {
  display: flex;
  align-items: center;
}
.btnDiv {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  .btn {
    width: 90%;
    padding: 10px 0;
    background: linear-gradient(270deg, #00706E, #00706E);
    border: 0;
    border-radius: 30px;
    color: white;
    font-size: 1.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backSchool/AppointmentCollective.vue